import * as React from "react";
import { cn } from "@/lib/cn";

export const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(function Card({ className, ...rest }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        "rounded-lg border border-border bg-bg-elevated p-6",
        className,
      )}
      {...rest}
    />
  );
});

export const CardHeader = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("mb-4 space-y-1", className)} {...rest} />
);

export const CardTitle = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2
    className={cn("text-xl font-semibold tracking-tight text-fg", className)}
    {...rest}
  />
);

export const CardDescription = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn("text-sm text-fg-muted", className)} {...rest} />
);

export const CardContent = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("space-y-4", className)} {...rest} />
);
